@if (dialogService.isOpen('language')) {
  <div class="fixed inset-0 z-50 flex flex-col bg-white lg:hidden">
    <!-- Header -->
    <div
      class="flex items-center justify-between border-b border-neutral-300 p-4"
    >
      <h2 class="text-xl font-medium text-neutral-800">
        {{ 'components.header.selectLanguage' | translate }}
      </h2>
      <button
        class="flex items-center rounded-lg p-2 text-neutral-800"
        (click)="closeLanguageModal()"
        aria-label="Close language modal"
      >
        {{ 'components.header.close' | translate }}
        <img class="ml-2 h-4 w-4" src="/assets/icons/close.svg" alt="Close" />
      </button>
    </div>
    <!-- Language Options -->
    <div class="flex-1">
      @for (lang of enabledLanguages(); track lang) {
        <button
          class="flex w-full items-center justify-between border-b border-neutral-300 px-4 py-4 text-base font-normal text-neutral-800 transition-colors duration-200 hover:text-orange-500"
          [class.text-orange-500]="currentLanguage() === lang"
          (click)="selectLanguage(lang)"
        >
          {{ lang | uppercase }}
          @if (currentLanguage() === lang) {
            <img class="h-4 w-4" src="assets/icons/check.svg" alt="Selected" />
          }
        </button>
      }
    </div>
  </div>
}
